"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _times = require("HubStyleTokens/times");

var _react = _interopRequireWildcard(require("react"));

var _useMounted = _interopRequireDefault(require("react-utils/hooks/useMounted"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var PopTransitionWrapper = _styledComponents.default.div.withConfig({
  displayName: "AlertListTransition__PopTransitionWrapper",
  componentId: "c6a6ue-0"
})(["opacity:", ";transform:scale(", ");transition-property:'opacity, transform';transition-duration:", ";pointer-events:", ";"], function (_ref) {
  var open = _ref.open;
  return open ? '1' : '0';
}, function (_ref2) {
  var open = _ref2.open;
  return open ? '1' : '0.9';
}, _times.FLOATING_ALERT_TIMING, function (_ref3) {
  var open = _ref3.open;
  return !open && 'none';
});

var renderWrappedChild = function renderWrappedChild(child, open) {
  return _react.default.createElement(PopTransitionWrapper, {
    className: "private-floating-alert-list__child",
    key: child.key,
    open: open
  }, child);
};

var PopTransition = function PopTransition(_ref4) {
  var children = _ref4.children;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      visibleChildren = _useState2[0],
      setVisibleChildren = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      leavingChildrenKeys = _useState4[0],
      setLeavingChildrenKeys = _useState4[1];

  var mountedRef = (0, _useMounted.default)(); // Child add/remove logic

  (0, _react.useEffect)(function () {
    var visibleChildrenKeys = visibleChildren.reduce(function (acc, visibleChild) {
      acc[visibleChild.key] = true;
      return acc;
    }, {});
    var removedChildrenKeys = Object.assign({}, visibleChildrenKeys); // Merge our existing set of visible children with any new children

    _react.Children.forEach(children, function (child) {
      var childKey = child && child.key;
      if (!childKey) return;

      if (!visibleChildrenKeys[childKey]) {
        // A new child has been added
        setVisibleChildren(function (prevVisibleChildren) {
          return prevVisibleChildren.concat(renderWrappedChild(child, false));
        }); // Start "enter" animation

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (!mountedRef.current) return;
            setVisibleChildren(function (prevVisibleChildren) {
              return prevVisibleChildren.map(function (c) {
                return c.key === childKey ? (0, _react.cloneElement)(c, {
                  open: true
                }) : c;
              });
            });
          });
        });
      }

      delete removedChildrenKeys[childKey];
    }); // Handle removed children


    Object.keys(removedChildrenKeys).forEach(function (removedKey) {
      if (leavingChildrenKeys[removedKey]) return;
      setLeavingChildrenKeys(function (prevLeavingChildrenKeys) {
        return Object.assign({}, prevLeavingChildrenKeys, (0, _defineProperty2.default)({}, removedKey, true));
      }); // Start "leave" animation, then remove the item completely afterward.

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!mountedRef.current) return;
          setVisibleChildren(function (prevVisibleChildren) {
            return prevVisibleChildren.map(function (c) {
              return c.key === removedKey ? (0, _react.cloneElement)(c, {
                open: false
              }) : c;
            });
          });
          setTimeout(function () {
            if (!mountedRef.current) return;
            setVisibleChildren(function (prevVisibleChildren) {
              return prevVisibleChildren.filter(function (c) {
                return c.key !== removedKey;
              });
            });
            setLeavingChildrenKeys(function (prevLeavingChildrenKeys) {
              return Object.assign({}, prevLeavingChildrenKeys, (0, _defineProperty2.default)({}, removedKey, false));
            });
          }, parseInt(_times.FLOATING_ALERT_TIMING, 10));
        });
      });
    });
  }, [children]); // eslint-disable-line react-hooks/exhaustive-deps

  return visibleChildren;
};

var AlertListTransition = function AlertListTransition(props) {
  return _react.default.createElement(PopTransition, props);
};

AlertListTransition.displayName = 'AlertListTransition';
var _default = AlertListTransition;
exports.default = _default;
module.exports = exports.default;